import React from 'react';

import { CardContainer, Stat, Text } from './StatCard.styled';

export interface Props {
    stat: string;
    text: string;
}

const StatCard: React.FC<Props> = props => {
    const { stat, text } = props;

    return (
        <CardContainer>
            <Stat>{stat}</Stat>
            <Text>{text}</Text>
        </CardContainer>
    );
};

export default StatCard;
